// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__Y8TRq","ellipsis":"styles_ellipsis__rMPRH","text2AndMoreLines":"styles_text2AndMoreLines__U1va2","tooltipTrigger":"styles_tooltipTrigger__q4O5K"};